import store from '@/store';

export default (to, from, next) => {

    if (to.matched.some(record => record.meta?.profile === 'broadband')) {
        return Promise.resolve({ allow: true });
    }
    
    const isFWAProduct = store.getters.is_account_type_fwa;
    const isUFBProduct = store.getters.is_account_type_ufb;
    const isMobileProduct = store.getters.is_mobile_product

    let allow
    
    if (isFWAProduct || isUFBProduct) {
        allow = true
    } else if (isMobileProduct) {
        allow = !store.getters.is_account_type_activated || 
                (store.getters.is_account_type_activated && 
                 (store.getters.customer_current_product_has_base_plan || 
                  store.getters.no_addons_notified))
    } else {
        allow = !store.getters.is_account_type_activated;
    }

    if (!allow) {
        return Promise.reject({
            allow,
            redirect: { name: 'no-addons-page' },
        })
    }

    return Promise.resolve({
        allow,
        redirect: { name: 'home' },
    })
};
